import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
const USE_CASES = [{
  need: '¿Necesitás preparar el contenido del mes?',
  tool: 'Calendario Pro'
}, {
  need: '¿No sabés qué subir a Stories?',
  tool: 'Ingeniería de Stories'
}, {
  need: '¿Querés grabar un Reel?',
  tool: 'Reels de Alto Valor'
}, {
  need: '¿Te llegó una consulta por DM?',
  tool: 'El Cierre Maestro'
}, {
  need: '¿Tu perfil no transmite profesionalismo?',
  tool: 'Arquitectura Visual'
}, {
  need: '¿No sabés para qué publicás?',
  tool: 'La Recepcionista Digital'
}];
export function ToolboxSection() {
  return <section className="bg-blush py-12 sm:py-16" data-id="element-213" data-mp="jiqycesd6g7o">
      <div className="mx-auto max-w-4xl px-5" data-id="element-214" data-mp="er8w7nelu9l4">
        <div className="text-center" data-id="element-215" data-mp="eqgzuad6o7ts">
          <SectionTag data-id="element-216" data-mp="epfo03ocfhb0">Cómo se usa</SectionTag>
          <h2 className="mt-3 font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-217" data-mp="3n6ak90amy3g4">
            Tu caja de herramientas de trabajo
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-218" data-mp="1slk4o6kvgzbj">
            No comprás seis libros para leer algún día. Recibís un sistema de consulta para usar
            mientras gestionás el Instagram de tu estética.
          </p>
        </div>

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-219" data-mp="22dgegewbmdvl">
          {USE_CASES.map(u => <li key={u.tool} className="flex items-center gap-3 rounded-xl border border-rose/10 bg-white px-4 py-3.5 shadow-sm" data-id="element-220" data-mp="26f1nfp5qi80i">
              <span className="flex-1 text-sm leading-snug text-ink/75" data-id="element-221" data-mp="1emkh7293iqgy">{u.need}</span>
              <ArrowRightIcon className="h-4 w-4 shrink-0 text-rose" aria-hidden data-id="element-222" data-mp="1imbd1kdhbwsc" />
              <span className="shrink-0 text-sm font-semibold text-rose-deep" data-id="element-223" data-mp="1nmz589dg2jo5">{u.tool}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}